import React, { Fragment } from "react"

import BackgroundImage from "./BackgroundImage"
import Tags from "./tags/Tags"
import TagItem from "./tags/TagItem"
import { range } from "../../config/util-functions"
import PlaceholderImageListItemShadow from "./PlaceholderImageListItemShadow"

const PlaceholderImageViewWidget = ({
    placeholders,
    isInheritEnabled,
    isInheritingPlaceholders,
    inheritFrom,
    isFetching
}) => (
    <div className="widget">
        <h3 className="widget-header">
            <span className="icon icon-heroimg" />
            Article placeholder images
        </h3>
        <div className="widget-content manage-images placeholders-gallery auto">
            {isInheritEnabled &&
            isInheritingPlaceholders && (
                <Fragment>
                    <div className="icon icon-checked" />
                    <p>Inheriting from Primary Insight Area</p>
                    {inheritFrom && (
                        <Tags>
                            <TagItem>{inheritFrom.name}</TagItem>
                        </Tags>
                    )}
                </Fragment>
            )}
            {isFetching &&
                range(3).map(index => (
                    <PlaceholderImageListItemShadow key={index} />
                ))}
            {(placeholders || []).map(({ url, attribution }) => (
                <div className="placeholder-box" key={url}>
                    <BackgroundImage
                        imageUrl={url}
                        classList={["placeholder-image"]}
                        isThumbnail={true}
                    />
                    <div className="placeholder-caption">
                        {attribution || "No attribution"}
                    </div>
                </div>
            ))}
            {(!placeholders || placeholders.length === 0) &&
                !isInheritingPlaceholders &&
                "No placeholders"}
        </div>
    </div>
)

export default PlaceholderImageViewWidget
